import { ref } from "vue"

const useDetailsModal = () => {
    const isDetailsModalActive = ref(false)

    const activeAppointmentId = ref(null)

    const openDetailsModal = (appointment_id) => {
        // if match with activeAppointmentId
        if (activeAppointmentId.value == appointment_id) {
            isDetailsModalActive.value = false
            activeAppointmentId.value = null
            return
        } 


        activeAppointmentId.value = null
        isDetailsModalActive.value = false

        setTimeout(() => {
            isDetailsModalActive.value = true
            console.log('open details modal', appointment_id, isDetailsModalActive.value)
            activeAppointmentId.value = appointment_id
        }, 200)
    }

    const closeDetailsModal = () => {
        isDetailsModalActive.value = false
        activeAppointmentId.value = null
    }

    /** 
     * Calculate position of details modal
     * 
     * @param {number} row_index
     * @param {number} col_index - Day (0 - 6)
     * @param {string} period - [Month, Week, Day]
     * @returns {string} - style
     */
    const calculateDetailsModalPosition = (row_index = 0, col_index = 0, period, isMore = false) => {
        let style = ""
        let horizontalPosition = ""
        let verticalPosition = ""

        switch (period) {
            case "Month":
                if (isMore) {
                    horizontalPosition = col_index < 3 ? "left:calc(100% + 5px) !important;" : "right:calc(100% + 5px) !important;"
                    verticalPosition = row_index < 3 ? "top: -50px !important;" : "bottom: -50px !important;"
                } else {
                    horizontalPosition = col_index < 3 ? "left:calc(100% + 20px) !important;" : "right:calc(100% + 20px) !important;"
                    verticalPosition = row_index < 3 ? "top: -50px !important;" : "bottom: -50px !important;"
                }

                style = `${horizontalPosition} ${verticalPosition}`
                return style
            case "Week":
                horizontalPosition = col_index < 3 ? "left:calc(100% + 7px) !important;" : "right:calc(100% + 7px) !important;"
                verticalPosition = "top:0px;"
                style = `${horizontalPosition} ${verticalPosition}`
                return style
            case "Day":
                horizontalPosition = "left:calc(50% - 186px);"
                verticalPosition = "top:0px;"
                style = `${horizontalPosition} ${verticalPosition}`
                return style
        }
    }

    const calculateArrowPosition = (col_index = 0, period) => {
        let month = {
            style: col_index < 3 ? "right: -22px;" : "left: -22px ;rotate: 180deg;",
            isRotated: col_index > 3
        }

        let week = {
            style: col_index < 3 ? "right: -12px;" : "left: -12px ;rotate: 180deg;",
            isRotated: col_index > 3
        }

        let day = {
            style: "left:calc(50% - 195px);",
            isRotated: false
        }

        switch (period) {
            case "Month":
                return month
            case "Week":
                return week
            case "Day":
                return day
            default:
                return month
        }
    }


    return { isDetailsModalActive, activeAppointmentId, openDetailsModal, closeDetailsModal, calculateDetailsModalPosition, calculateArrowPosition }
}

export default useDetailsModal
